"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchL1CategoriesAndTerminalNodesForStrategyMatrix = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const graphql_1 = require("../../../../__generated__/graphql");
const gql_1 = require("../gql");
const use_get_search_l1_categories_and_terminal_nodes_utils_1 = require("./use-get-search-l1-categories-and-terminal-nodes.utils");
const client_constants_1 = require("../../../client/client.constants");
const client_utils_1 = require("../../../client/client.utils");
const useSearchL1CategoriesAndTerminalNodesForStrategyMatrix = ({ productTreeId, searchTerm, }) => {
    const { data, error, networkStatus } = (0, react_2.useQuery)(gql_1.SEARCH_L1_CATEGORIES_AND_TERMINAL_NODES_FOR_STRATEGY_MATRIX, {
        variables: {
            productTreeId,
            first: 2, // We assume we ALWAYS have at least 2 ancestors, the first is "Ontology"
            query: searchTerm,
            sort: [{ distance: graphql_1.SortOrder.Asc }],
            searchProductTreeNodeFirst: client_constants_1.SEARCH_RESULTS_LIMIT,
            vectorWeight: client_constants_1.VECTOR_WEIGHT,
        },
        skip: !productTreeId || !searchTerm,
    });
    const isLoading = (0, client_utils_1.isQueryLoadingOrRefetching)(networkStatus);
    /**
     * We assume we ALWAYS have at least 2 ancestors, the first is "Ontology"
     * and the second is the L1 category we want.
     */
    const groupedOptions = (0, react_1.useMemo)(() => (0, use_get_search_l1_categories_and_terminal_nodes_utils_1.buildSearchL1CategoryGroupedOptions)(data === null || data === void 0 ? void 0 : data.searchProductTreeNode), [data]);
    return {
        data: groupedOptions,
        isLoading,
        error,
    };
};
exports.useSearchL1CategoriesAndTerminalNodesForStrategyMatrix = useSearchL1CategoriesAndTerminalNodesForStrategyMatrix;
